export const Actions = {
  SHORTCUT: {
    VIEW: "SHORTCUT__VIEW",
    CREATE_INVITE_PATIENT: "SHORTCUT__CREATE_INVITE_PATIENT",
    SEND_FILL_OUT_SURVEY: "SHORTCUT__SEND_FILL_OUT_SURVEY",
    CREATE_OUTCOMES_EVENT: "SHORTCUT__CREATE_OUTCOMES_EVENT",
    SEND_MESSAGE: "SHORTCUT__SEND_MESSAGE",
    CREATE_CALENDAR_EVENT: "SHORTCUT__CREATE_CALENDAR_EVENT",
    // CREATE_PRESCRIPTION: "SHORTCUT__CREATE_PRESCRIPTION",
  },
  AINAVIGATOR: {
    VIEW: "AINAVIGATOR__VIEW",
    OPEN_MODAL_PATIENT: "AINAVIGATOR__OPEN_MODAL_PATIENT",
    SELECT_FOLLOW_UP_PATIENT: "AINAVIGATOR__SELECT_FOLLOW_UP_PATIENT",
    OPEN_MODAL_ADD_PATIENT: "AINAVIGATOR__OPEN_MODAL_ADD_PATIENT",
    // ---
    PATIENTS: "AINAVIGATOR__PATIENTS",
    FOLLOW_UP: "AINAVIGATOR__FOLLOW_UP",
    FOLLOW_RPM: "AINAVIGATOR__RPM",
    BARRIERS: "AINAVIGATOR__BARRIERS",
    GO_PATIENT_MANAGEMENT: "AINAVIGATOR__GO_PATIENT_MANAGEMENT",
    SEARCH_PATIENT: "AINAVIGATOR__SEARCH_PATIENT",
    ORDER_PATIENT_NAME: "AINAVIGATOR__ORDER_PATIENT_NAME",
    ORDER_PATIENT_DATE: "AINAVIGATOR__ORDER_PATIENT_DATE",
    FILTER_PATIENT_PROGRAM: "AINAVIGATOR__FILTER_PATIENT_PROGRAM",
    FILTER_PATIENT_PROGRAM_STATUS: "AINAVIGATOR__FILTER_PATIENT_PROGRAM_STATUS",
    FILTER_BARRIERS_PROGRAM: "AINAVIGATOR__FILTER_BARRIERS_PROGRAM",
  },
  AINAVIGATOR_MODAL: {
    CHANGE_PROGRAM_STATUS: "AINAVIGATOR_MODAL__CHANGE_PROGRAM_STATUS",
    GO_OUTCOMES: "AINAVIGATOR_MODAL__GO_OUTCOMES",
    GO_AGENDA: "AINAVIGATOR_MODAL__GO_AGENDA",
    GO_FOLLOW_UP: "AINAVIGATOR_MODAL__GO_FOLLOW_UP",
    GO_REPORTS: "AINAVIGATOR_MODAL__GO_REPORTS",
    GO_HEALTH: "AINAVIGATOR_MODAL__GO_HEALTH",
    GO_MONACO: "AINAVIGATOR_MODAL__GO_MONACO",
    GO_NOTES: "AINAVIGATOR_MODAL__GO_NOTES",
    // ---
    CLOSE: "AINAVIGATOR_MODAL__CLOSE",
    ACTIVATE_GENERAL_NOTE_EDITION:
      "AINAVIGATOR_MODAL__ACTIVATE_GENERAL_NOTE_EDITION",
    GENERAL_NOTE_EDITION: "AINAVIGATOR_MODAL__GENERAL_NOTE_EDITION",
    CANCEL_GENERAL_NOTE_EDITION:
      "AINAVIGATOR_MODAL__CANCEL_GENERAL_NOTE_EDITION",
  },
  STATUS_MANAGEMENT: {
    // ---
    CHANGE_STATUS: "STATUS_MANAGEMENT__CHANGE_STATUS",
    SAVE_STATUS: "STATUS_MANAGEMENT__SAVE_STATUS",
    CANCEL_STATUS: "STATUS_MANAGEMENT__CANCEL_STATUS",
  },
  OUTCOMES: {
    VIEW: "OUTCOMES__VIEW",
    SELECT_PROGRAM: "OUTCOMES__SELECT_PROGRAM",
    TIMELINE: "OUTCOMES__TIMELINE",
    DASHBOARD: "OUTCOMES__DASHBOARD",
    MEDICAL_GRAPHIC: "OUTCOMES__MEDICAL_GRAPHIC",
    MEDICAL_TABLE: "OUTCOMES__MEDICAL_TABLE",
    ADD_UPDATE: "OUTCOMES__ADD_UPDATE",
  },
  SUVERYS_SECTIONS: {
    VIEW: "SUVERYS_SECTIONS__VIEW",
  },
  HEALTH: {
    VIEW: "OUTCOMES__VIEW",
    CREATE_MEDICATION: "HEALTH__CREATE_MEDICATION",
    CREATE_VITAL_SIGNS: "HEALTH__CREATE_VITAL_SIGNS",
    REGISTER_VITAL_SIGN: "HEALTH__REGISTER_VITAL_SIGN",
    REPORT_SYMPTOMS: "HEALTH__REPORT_SYMPTOMS",
  },
  FOLLOW_UP: {
    MINIMIZE: "FOLLOW_UP__MINIMIZE",
    MAXIMIZE: "FOLLOW_UP__MAXIMIZE",
    CLOSE: "FOLLOW_UP__CLOSE",
    // ---
    GO_TO_HEALTH: "FOLLOW_UP__GO_TO_HEALTH",
    GO_TO_REPORTS: "FOLLOW_UP__GO_TO_REPORTS",
    GO_TO_AGENDA: "FOLLOW_UP__GO_TO_AGENDA",
    GO_TO_CHAT: "FOLLOW_UP__GO_TO_CHAT",
  },
  ALERTS: {
    COMPACT_VIEW: "ALERTS__COMPACT_VIEW",
    ALERTS_VIEW: "ALERTS__ALERTS_VIEW",
    FILTERS: "ALERTS__FILTERS",
    CARD: "ALERTS__CARD",
    SELECT_PATIENT: "ALERTS__SELECT_PATIENT",
  },
  AGENDA: {
    VIEW: "AGENDA__VIEW",
    FILTERS: "AGENDA__FILTERS",
    CREATE_EVENT: "AGENDA__CREATE_EVENT",
    CARD: "AGENDA__CARD",
    SELECT_PATIENT: "AGENDA__SELECT_PATIENT",
  },
  MONACO: {
    CHAT: "MONACO__CHAT",
    CHAT_GENERAL: "MONACO__CHAT_GENERAL",
    CHAT_PATIENTS: "MONACO__CHAT_PATIENTS",
    CHAT_GUIDES: "MONACO__CHAT_GUIDES",
    CHAT_GUIDES_AND_PATIENTS: "MONACO__CHAT_GUIDES_AND_PATIENTS",
    CHAT_IMAGE_READING: "MONACO__CHAT_IMAGE_READING",
    CHAT_GUIDE_NAVIGATION_MODULE: "MONACO__CHAT_GUIDE_NAVIGATION_MODULE",
    MONACO_ALGORITHMS: "MONACO__MONACO_ALGORITHMS",
    MEDICAL_TRANSDUCTOR: "MONACO__MEDICAL_TRANSDUCTOR",
    MEDICAL_TRANSDUCTOR_HISTORY: "MONACO__MEDICAL_TRANSDUCTOR_HISTORY",

    CHAT_MEDICOL: "MONACO__CHAT_MEDICOL",
    CHAT_MEDICOL_GENERAL: "MONACO__CHAT_MEDICOL_GENERAL",
    CHAT_MEDICOL_PATIENTS: "MONACO__CHAT_MEDICOL_PATIENTS",
    CHAT_MEDICOL_GUIDES: "MONACO__CHAT_MEDICOL_GUIDES",
    CHAT_MEDICOL_GUIDES_AND_PATIENTS:
      "MONACO__CHAT_MEDICOL_GUIDES_AND_PATIENTS",
  },
  ALGORITHMS: {
    VIEW: "ALGORITHMS__VIEW",
    SELECT_PROGRAM: "ALGORITHMS__SELECT_PROGRAM",
  },
  CHAT: {
    VIEW: "CHAT__VIEW",
  },
};
